var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "groupBox", style: _vm.boxPadding }, [
        _c("div", { staticClass: "group", style: _vm.boxStyle }, [
          _c(
            "div",
            {
              staticClass: "group-top acea-row row-middle row-between",
              style: _vm.selectBgImg == 0 ? _vm.bgImgStyle : "",
            },
            [
              _c("div", { staticClass: "group-top-left acea-row" }, [
                _vm.selectStyle == 0
                  ? _c("img", {
                      staticClass: "headerLogo",
                      attrs: { src: _vm.logoUrl, alt: "" },
                    })
                  : _c(
                      "div",
                      {
                        staticClass: "titleFont",
                        style: _vm.headerTitleConfig,
                      },
                      [_vm._v(_vm._s(_vm.titleConfig))]
                    ),
              ]),
              _c(
                "div",
                { staticClass: "group-top-right", style: _vm.headerBtnColor },
                [
                  _vm._v(" 更多 "),
                  _c("span", {
                    staticClass: "iconfont icon-xuanze",
                    style: _vm.headerBtnColor,
                  }),
                ]
              ),
            ]
          ),
          _vm.listStyle == 0
            ? _c(
                "div",
                {
                  staticClass:
                    "group-bottom two acea-row row-between grid-list",
                  style: _vm.boxBgStyle,
                },
                _vm._l(2, function (item, index) {
                  return _c("div", { key: index }, [
                    _c("div", { staticClass: "group-bottom-left" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "img acea-row row-center row-middle big-img",
                          style: _vm.contentStyle,
                        },
                        [
                          _c("img", {
                            staticClass: "shan",
                            attrs: {
                              src: require("@/assets/imgs/shan.png"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "two-item" }, [
                      _c("div", { staticClass: "title acea-row" }, [
                        _vm.typeShow.includes(0)
                          ? _c(
                              "span",
                              { staticClass: "line1", style: _vm.nameColor },
                              [
                                _vm._v(
                                  "THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _c(
                        "div",
                        { staticClass: "two-item-bottom acea-row row-between" },
                        [
                          _c("div", { staticClass: "price" }, [
                            _vm.typeShow.includes(2)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pinkNum semiBold acea-row row-middle f-s-16",
                                    style: _vm.priceColor,
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "priceNum-img",
                                      attrs: {
                                        src: require("@/assets/imgs/intergral-icon.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c("span", [_vm._v("688800")]),
                                    _c("span", [_vm._v("+")]),
                                    _c("span", [_vm._v("67000元")]),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm.listStyle == 1
            ? _c(
                "div",
                {
                  staticClass: "group-bottom three acea-row grid-three",
                  style: _vm.boxBgStyle,
                },
                _vm._l(3, function (item, index) {
                  return _c("div", { key: index, staticClass: "three-box" }, [
                    _c("div", { staticClass: "group-bottom-left" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "img acea-row row-center row-middle three-img",
                          style: _vm.contentStyle,
                        },
                        [
                          _c("img", {
                            staticClass: "shan",
                            attrs: {
                              src: require("@/assets/imgs/shan.png"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "two-item" }, [
                      _c("div", { staticClass: "two-item-bottom" }, [
                        _c("div", { staticClass: "price" }, [
                          _vm.typeShow.includes(2)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "pinkNum semiBold acea-row row-middle f-s-14",
                                  style: _vm.priceColor,
                                },
                                [
                                  _c("img", {
                                    staticClass: "priceNum-img",
                                    attrs: {
                                      src: require("@/assets/imgs/intergral-icon.png"),
                                      alt: "",
                                    },
                                  }),
                                  _c("span", [_vm._v("688800")]),
                                  _c("span", [_vm._v("+")]),
                                  _c("span", [_vm._v("670元")]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c("div", { staticClass: "title acea-row" }, [
                        _vm.typeShow.includes(0)
                          ? _c(
                              "span",
                              { staticClass: "line1", style: _vm.nameColor },
                              [
                                _vm._v(
                                  "THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 THE ROW 休闲针织衫女2024春秋深藏青条纹毛衣女羊绒真丝套头上衣 "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm.listStyle == 2
            ? _c(
                "div",
                {
                  staticClass: "group-bottom four acea-row",
                  style: _vm.boxBgStyle,
                },
                _vm._l(3, function (item, index) {
                  return _c("div", { key: index, staticClass: "four-item" }, [
                    _c("div", { staticClass: "group-bottom-left" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "img acea-row row-center row-middle four-img",
                          style: _vm.contentStyle,
                        },
                        [
                          _c("img", {
                            staticClass: "shan",
                            attrs: {
                              src: require("@/assets/imgs/shan.png"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "two-item" }, [
                      _c("div", { staticClass: "two-item-bottom" }, [
                        _c("div", { staticClass: "price" }, [
                          _vm.typeShow.includes(2)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "pinkNum semiBold acea-row row-middle f-s-14",
                                  style: _vm.priceColor,
                                },
                                [
                                  _c("img", {
                                    staticClass: "priceNum-img",
                                    attrs: {
                                      src: require("@/assets/imgs/intergral-icon.png"),
                                      alt: "",
                                    },
                                  }),
                                  _c("span", [_vm._v("688800")]),
                                  _c("span", [_vm._v("+")]),
                                  _c("span", [_vm._v("6700元")]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }